import { render, staticRenderFns } from "./SetDonorCaseOfficer.vue?vue&type=template&id=22a58256"
import script from "./SetDonorCaseOfficer.vue?vue&type=script&lang=js"
export * from "./SetDonorCaseOfficer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports